import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import '@/plugins/axios'
import ElementUI from 'element-ui';

import locale from 'element-ui/lib/locale/lang/en'


import VueI18n from 'vue-i18n'
window.Vue = Vue
window.lang = localStorage.getItem('lang') || ''
const language = navigator.language || navigator.userLanguage;
console.log(lang)
if (language !== 'zh-CN' && !lang) {
  lang = 'en'
}
if (!lang) {
  lang = 'zh-CN'
}
const i18n = new VueI18n({
  locale: lang,
  messages: {
    'zh-CN': require('./i18n/chs.js'),
    en: require('./i18n/en.js')
  }
})
import '@/assets/theme/index.css';
Vue.config.productionTip = false
Vue.use(ElementUI, { locale })

new Vue({
  i18n,
  router,
  store,
  render: h => h(App)
}).$mount('#app')
